import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from './../common/services/sharedService';
import { CommonConstants } from './../common/utilities/commonConstants';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
@Component({
    templateUrl: './multitabFailed.template.html',
    styleUrls: ['./multitabFailed.style.scss'],
})
export class MultitabFailedComponent implements OnInit {
    private isbrowserBackPressed: boolean;
    public exploreUrl = 'https://www.bajajfinservmarkets.in/';
    public exploreUrlBFL = 'https://www.bajajfinserv.in/insurance?utm_source=insurancemarketplace&utm_medium=health&utm_campaign=thankyoupage&utm_content=paymentsuccess&utm_term=';
    bflJourney: any;
    constructor(
        private _sharedService: SharedService,
        private _routeContextProvider: RouteContextProvider,
        private _sessionHandler: SessionHandlerService,
        private _adobe_analytics_service: adobe_analytics_service
    ) { }
    public ngOnInit() {
        // browser back button changes
        this._sessionHandler.FlushAll();
        this.isbrowserBackPressed = this._sharedService.getData('brwoserback');
        if (this.isbrowserBackPressed) {
            this._routeContextProvider.NavigateToView([CommonConstants.Routes.MultitabFailed]);
        }
    }
    public ExploreMore() {
        let url: any = window.location.pathname;
        url = url.split("/");
        this.bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
        const exploreMore = this.bflJourney ? this.exploreUrlBFL : this.exploreUrl;
        window.open(exploreMore, '_self');
    }
}
